export const startWaiting = () => ({ type: 'chat/startWaiting' });
export const stopWaiting = () => ({ type: 'chat/stopWaiting' });
